/* MUI */
import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Paper,
    TextField,
    Typography
} from '@mui/material';

/* Shared */
import { PartnerBackButton } from 'application/Shared/Components/Buttons/BackButton';
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';
import { Notify } from 'application/Shared/Helpers';
import Core from 'application/Shared/Helpers/Functions';
import { Requests } from 'application/Shared/Requests';

/* NPM */
import axios from 'axios';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/* React */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class CWManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: [],
            loaded: false
        };

        /* requests */
        this.requests = new Requests();
    }

    async componentDidMount() {
        const state = { loaded: true };
        try {
            const response = await axios.get('/integrations', {
                cancelToken: this.requests.token(),
                params: { key: 'cw_manage' }
            });

            if (Core.isset(response, 'data', 'data', 0)) {
                state.fields = response.data.data;
                state.fields.forEach((field) => {
                    if (field.value !== null) {
                        state[field.fieldKey] = field.value;
                    } else {
                        state[field.fieldKey] = field.default;
                    }
                });
            }
        } catch (err) {
            // Notify.error(t('Common.error'));
        }

        this.setState(state);
    }

    componentWillUnmount() {
        this.unload();
    }

    unload = () => {
        this.requests.cancel();
    };

    save = () => {
        const { t } = this.props;
        const { fields } = this.state;

        fields.forEach(async (field) => {
            const key = field?.fieldKey;
            if (key) {
                const { [key]: stateFieldKey } = this.state;
                const payload = {
                    field: field.fieldKey,
                    key: 'cw_manage',
                    value: stateFieldKey
                };
                await axios.post('/integrations/', payload);
            }
        });

        Notify.success(t('PartnerIntegration.save_successful'));
    };

    render() {
        const { session, t } = this.props;
        const { fields, loaded } = this.state;

        if (!loaded) {
            return null;
        }

        const userTheme = getUserTheme(session?.user?.theme);

        return (
            <>
                <Box width="100%">
                    <Typography variant="h3">
                        {t('ClientSettings.title')}
                    </Typography>
                    <hr />
                </Box>
                <PartnerBackButton
                    linkTo="/integrations/partnerLevel"
                    textOverride="Integrations.Common.back"
                />
                <Paper elevation={0} variant="outlined">
                    <Grid container spacing={0}>
                        <img
                            src={`/images/${userTheme}/integrations/cw_manage.png`}
                            alt={t('Integrations.ConnectWiseManage.logo')}
                            style={{
                                paddingBottom: '24px',
                                paddingTop: '24px',
                                width: '200px'
                            }}
                        />
                        <br />
                        <Grid item xs={12}>
                            Please refer to the&nbsp;
                            <a
                                className="link underline"
                                target="_blank"
                                href="https://support.auvik.com/hc/en-us/articles/10857735707156"
                                rel="noopener noreferrer nofollow"
                                style={{ fontWeight: 600 }}
                                data-trackid="partner_integrations_cwManage_guide"
                            >
                                {t('Deployment.integrations_guide')}
                            </a>
                            &nbsp;for setting up ConnectWise Manage setup.
                        </Grid>
                        <br />
                        <br />
                        {fields.map((field) => {
                            const { [field?.fieldKey]: stateFieldKey } =
                                this.state;
                            return (
                                <Grid item xs={12} key={field.fieldKey}>
                                    {field.type !== 'boolean' && (
                                        <Box display="flex" alignItems="center">
                                            <Typography
                                                color="textSecondary"
                                                variant="body2"
                                                style={{ fontWeight: 600 }}
                                            >
                                                {t(field.label)}
                                            </Typography>
                                            <TooltipQ
                                                text={t(field.tooltip)}
                                                size={FontSizes[1]}
                                            />
                                        </Box>
                                    )}
                                    {field.type === 'boolean' && (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            mb="24px"
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={stateFieldKey}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                [field.fieldKey]:
                                                                    e.target
                                                                        .checked
                                                            })
                                                        }
                                                        label={t(field.label)}
                                                    />
                                                }
                                            />
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                            >
                                                <Typography>
                                                    {t(field.label)}
                                                </Typography>
                                                <TooltipQ
                                                    text={t(field.tooltip)}
                                                    size={FontSizes[1]}
                                                />
                                            </Box>
                                        </Box>
                                    )}
                                    {(field.type === 'text' ||
                                        field.type === 'email') && (
                                        <>
                                            <TextField
                                                onChange={(e) => {
                                                    this.setState({
                                                        [field.fieldKey]:
                                                            e.target.value
                                                    });
                                                }}
                                                value={stateFieldKey}
                                                style={{ width: 300 }}
                                            />
                                            <br />
                                            <br />
                                        </>
                                    )}
                                </Grid>
                            );
                        })}
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <hr />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                data-trackid="integrationsCWManageSaveBtn"
                                color="primary"
                                onClick={() => this.save()}
                                style={{ float: 'right' }}
                                variant="contained"
                            >
                                {t('Common.save_settings')}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </>
        );
    }
}
export default withTranslation()(CWManage);
